import selectInsurance from 'utils/selectInsurance';

const getInsuranceName = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  return selectedInsurance
    && selectedInsurance['Insurance Info']
    && selectedInsurance['Insurance Info']['Payer Name']
    ? selectedInsurance['Insurance Info']['Payer Name'] : null;
};

export default getInsuranceName;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceName.js